import React from 'react'
import AleasPool from '../../js/AleasPool';
import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore';
import { store } from '../../stores/store';

import './AleasPopup.css'

const AleasPopup = () => {

  const aleas = AleasPool.getActiveAleas()


  return (
    <>
      <div className="overlay" onClick={() => PopupStore.close(POPUPS_IDS.ALEAS)} />
      <div className="top-left-popup">
        {aleas.length === 0 && store.t("no_alea")}
        {aleas.map(alea => {
          return (
          <div className="Alea" key={alea.id}>
            <div className="alea-name" dangerouslySetInnerHTML={{__html: alea.translated_name}} />
            <div className="alea-message"  dangerouslySetInnerHTML={{__html: alea.translated_message}} />
          </div>)
        })}
      </div>
    </>
  );
};

export default AleasPopup;
